<div class="row">
  <div class="col-12 padding-40">
    <div class="card-blueGDPR-container">
      <div class="d-flex flex-row requests-header">
        <img src="./assets/ui/svg/blue/icon-requests.svg">
        <h2>Your requests</h2>
      </div>
      <div>
        <div class="selection-row">
          <a (click)="showRequestedFiles('created')" [ngClass]="currentlyShowing==='created' ? 'active' : 'inactive'">Sent</a>
          <a (click)="showRequestedFiles('files_added')" [ngClass]="currentlyShowing==='files_added' ? 'active' : 'inactive'">Received</a>
          <button (click)="openSendRequestDialog()">Send request</button>
        </div>

        <app-request-item-selection-baner [currentlySelected]="currentlySelected" [isAllSelected]="isAllSelected" (onAction)="handleAction($event)"></app-request-item-selection-baner>

        <div *ngIf="loading; else noData" class="empty-data">
          <app-loader *ngIf="loading" label="Loading request"></app-loader>
        </div>

        <ng-template #noData>
          <div class="empty-data" *ngIf="requestedFiles.length === 0; else afterResponse">No data :(</div>
          <ng-template #afterResponse>
            <div class="request-item-container" @list>
              <div *ngFor="let item of requestedFiles" @item>
                <app-request-item [item]="item" (updateRequestItems)="checkShareItems()" (downloadRequestItems)="download($event)"></app-request-item>
              </div>
            </div>
          </ng-template>
        </ng-template>
      </div>

    </div>
  </div>
</div>
